import { createUseStyles } from 'react-jss'

import { colors } from '#base/js/variables.style'

export const style = {
  highlight: {
    fill: colors.silver,
    fillOpacity: '0.9'
  },
  flow: {
    fill: colors.silver,
    fillOpacity: '0.3'
  }
}

export const useCommonStyles = createUseStyles(style)
